import { render, staticRenderFns } from "./HistoryData.vue?vue&type=template&id=70caab0a&scoped=true&"
import script from "./HistoryData.vue?vue&type=script&lang=js&"
export * from "./HistoryData.vue?vue&type=script&lang=js&"
import style0 from "./HistoryData.vue?vue&type=style&index=0&id=70caab0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70caab0a",
  null
  
)

export default component.exports